import script from "./ApplyLowLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplyLowLabel.vue?vue&type=script&setup=true&lang=ts"

import "./ApplyLowLabel.vue?vue&type=style&index=0&id=790f154f&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790f154f"]])

export default __exports__